import React from "react";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/constants";

export const Testimonials = () => {
  const row1 = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section id="reviews" className="relative py-24 sm:py-32 bg-[#142238] overflow-hidden border-y border-slate-900" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mb-14">
        <div className="flex items-center gap-3 mb-4">
          <span className="h-px w-10 bg-[#1E88E5]" />
          <span className="font-heading text-xs font-bold tracking-[0.3em] uppercase text-[#1E88E5]">
            What customers say
          </span>
        </div>
        <h2 className="font-heading text-4xl sm:text-6xl font-black uppercase tracking-tight text-white">
          Five-star <span className="text-[#E6B445]">five times over.</span>
        </h2>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#142238] to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#142238] to-transparent z-10" />
        <div className="flex gap-6 animate-marquee" style={{ width: "max-content" }}>
          {row1.map((t, i) => (
            <div
              key={i}
              className="w-[360px] sm:w-[420px] shrink-0 bg-[#0B1726] border border-slate-800 p-8 rounded-md"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.stars }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#1E88E5] text-[#1E88E5]" />
                ))}
              </div>
              <p className="text-slate-200 text-base leading-relaxed mb-6">"{t.body}"</p>
              <div>
                <div className="font-heading font-bold uppercase tracking-wider text-white">
                  {t.name}
                </div>
                <div className="text-slate-500 text-sm">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
